import React from 'react'
import QuestionItem from './QuestionItem'
import List, { ListItem } from '@bt-react/components/List'
import styles from './styles/questionList.module.scss'
import { QuestionListProps } from '../constants/types'
import classNames from 'classnames'

const QuestionList = ({ listType, questions, handleQuestionIconClick, handleReplyClick }: QuestionListProps) => (
  <div
    data-bdd={`question-list-${listType}`}
    className={styles['question-list']}>
    <List
      dataBdd={`${listType}-questions-list`}
      className={classNames(styles[`question-management__question-list`], styles[`question-management__question-list--${listType}`])}
      separated={false}>
      { questions.map((question) =>
        <ListItem
          dataBdd={`${listType}-questions-list-item`}
          key={question.id}
          separated={true}
          className={styles[`question-management__list-item--${listType}`]}
          content={
            <QuestionItem
              question={question}
              key={question.id}
              listType={listType}
              uniqueConversationName={question.uniqueConversationName}
              showReplies={false}
              showUnreadNotification={question.numOfMessagesRead < question.messages.length - 1}
              handleQuestionIconClick={handleQuestionIconClick}
              questionReplies={question}
              handleReplyClick={handleReplyClick} />
          }
        />
      )}
    </List>
  </div>
)

export default QuestionList